// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Screen_wrapper__1HH4x"};